import LinkIcon from "assets/icons/LinkIcon";
import DeleteIcon from "assets/icons/DeleteIcon";
import { RefObject, useEffect, useRef } from "react";
import { useSelector } from "react-redux";
import { LoadingOutlined } from "@ant-design/icons";
import classNames from "classnames";

import styles from "./style.module.scss";
import ExportIcon from "../../../../assets/icons/ExportIcon";
import TubeIcon from "assets/icons/TubeIcon";
import { getExportStatus } from "redux/SingleDataset/selectors";

interface ActionOptionsProps {
  show: boolean;
  onToggle: () => void;
  onCopyClick: () => void;
  onDeleteClick: () => void;
  showDeleteOption: boolean;
  callerRef: RefObject<HTMLDivElement>;
  showExportOption: boolean;
  onExportClick?: () => void;
  showEvaluateLabelPropationOption?: boolean;
  onEvaluateLabelPropagationClick?: () => void;
}

const ActionOptions = ({
  show,
  onToggle,
  callerRef,
  onCopyClick,
  onDeleteClick,
  showDeleteOption,
  showExportOption,
  onExportClick,
  showEvaluateLabelPropationOption,
  onEvaluateLabelPropagationClick,
}: ActionOptionsProps) => {
  const exportStatus = useSelector(getExportStatus);
  const isExportInProgress = exportStatus === "IN_PROGRESS";
  const containerRef = useRef<HTMLDivElement>(null);

  const handleOutsideClick = (e: any) => {
    if (
      !containerRef.current?.contains(e.target) &&
      !callerRef.current?.contains(e.target)
    ) {
      onToggle();
    }
  };

  useEffect(() => {
    if (show) {
      document.addEventListener("mousedown", handleOutsideClick);
    } else {
      document.removeEventListener("mousedown", handleOutsideClick);
    }
    return () => {
      document.removeEventListener("mousedown", handleOutsideClick);
    };
    //eslint-disable-next-line
  }, [show]);

  return (
    <div ref={containerRef} className={styles.actionOptionsContainer}>
      <div className={styles.option} onClick={onCopyClick}>
        <div className={styles.optionIcon}>
          <LinkIcon />
        </div>
        <div className={styles.optionText}>Copy URL</div>
      </div>
      {showEvaluateLabelPropationOption && (
        <div
          className={styles.option}
          onClick={onEvaluateLabelPropagationClick}
        >
          <div className={styles.optionIcon}>
            <TubeIcon />
          </div>
          <div className={styles.optionText}>Evaluate Label Propagation</div>
        </div>
      )}
      {showExportOption && (
        <div
          className={classNames(styles.option, {
            [styles.disabled]: isExportInProgress,
          })}
          onClick={isExportInProgress ? undefined : onExportClick}
        >
          <div className={styles.optionIcon}>
            {isExportInProgress ? <LoadingOutlined /> : <ExportIcon />}
          </div>
          <div className={styles.optionText}>Export</div>
        </div>
      )}
      {showDeleteOption && (
        <div className={styles.option} onClick={onDeleteClick}>
          <div className={styles.optionIcon}>
            <DeleteIcon />
          </div>
          <div className={styles.optionText}>Delete</div>
        </div>
      )}
    </div>
  );
};

export default ActionOptions;
